import {
  Component,
  OnInit,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import Swal from 'sweetalert2';
import { CartService } from '../../../../services/cart';
import { LoginService } from '../../../Authentication/auth/login.service';
import { Router } from '@angular/router';
import { UrlSlugifyService } from '../../../../services/url-slugify';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {

  cartItems: any[] = [];
  tokenExists = false;
  isAr = false;
  private isBrowser: boolean;

  constructor(
    private cartService: CartService,
    private router: Router,
    private _slugify: UrlSlugifyService,
    private _LoginService: LoginService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {

    if (!this.isBrowser) return;

    window.scrollTo({ top: 0, behavior: 'smooth' });

    this.isAr = localStorage.getItem('language') === 'ar';

    this.loadCart();
    this.checkForToken();
  }

  // ================= AUTH =================
  checkForToken(): void {
    this._LoginService.token$.subscribe((token) => {
      this.tokenExists = token != null;
    });
  }
  isOnlyWheelRewardCart(): boolean {

    if (!this.cartItems || this.cartItems.length === 0) {
      return false;
    }

    const hasBundles = this.cartItems.some(item => item.type === 'bundle');
    if (hasBundles) return false;

    const rewardItems = this.cartItems.filter(
      item => item.product?.is_free_reward
    );

    const normalItems = this.cartItems.filter(
      item => !item.product?.is_free_reward
    );

    // لو فيه منتج عادي → عادي
    if (normalItems.length > 0) return false;

    // لو مفيش reward أصلاً → عادي
    if (rewardItems.length === 0) return false;

    // 🔥 هنا التعديل:
    // لو reward فقط وكمية كلهم = 1 → منع
    const allRewardsQtyOne = rewardItems.every(
      item => item.quantity === 1
    );

    return allRewardsQtyOne;
  }
  handleCheckout(): void {

    if (this.isOnlyWheelRewardCart()) {

      Swal.fire({
        icon: 'warning',
        title: this.isAr ? 'لا يمكن إتمام الطلب' : 'Cannot checkout',
        text: this.isAr
          ? 'لا يمكن إتمام الطلب بمنتج الهدية فقط. زوّد الكمية أو أضف منتج آخر.'
          : 'You cannot checkout with only the free reward item. Increase quantity or add another product.',
        confirmButtonText: this.isAr ? 'تمام' : 'OK',
        confirmButtonColor: '#3085d6'
      });

      return;
    }

    this.router.navigateByUrl('/Addorderclient');
  }



  // ================= CART =================
  loadCart(): void {
    this.cartItems = this.cartService.getCartItems();
  }

  // ✅ Increase Quantity
  increaseQuantity(item: any): void {

    if (item.type === "bundle") {
      this.cartService.addBundleToCart(item.product);
    } else {
      this.cartService.addToCart(item.product);
    }

    this.loadCart();
  }

  // ✅ Decrease Quantity
  decreaseQuantity(item: any): void {

    if (item.type === "bundle") {
      this.cartService.removeBundleFromCart(item.product);
    } else {
      this.cartService.removeFromCart(item.product);
    }

    this.loadCart();
  }

  // ✅ Clear Cart
  clearCart(): void {
    this.cartService.clearCart();

    if (this.isBrowser) {
      location.reload();
    }
  }

  // ================= TOTALS =================
  getTotal(): number {

    const total = this.cartItems.reduce((sum, item) => {

      const normalPrice = Number(
        item.product.is_daily_offer
          ? item.product.affiliationprice
          : item.product.pricea
      );

      if (item.product.is_free_reward) {

        // أول قطعة مجانية
        const paidQuantity = Math.max(item.quantity - 1, 0);

        return sum + (normalPrice * paidQuantity);
      }

      return sum + (normalPrice * item.quantity);

    }, 0);

    if (this.isBrowser) {
      localStorage.setItem('cartTotal', total.toString());
    }

    return total;
  }


  getDiscountTotal(): number {
    const discount = this.cartItems.reduce(
      (sum, item) => sum + Number(item.product.pricec) * item.quantity,
      0
    );

    if (this.isBrowser) {
      localStorage.setItem('cartDiscount', discount.toString());
    }

    return discount;
  }

  // ================= HELPERS =================
  fixImage(url: string): string {
    return `https://backendproduction.blueboxpet.com/storage/app/public/${url}`;
  }

  calcDis(newP: any, oldP: any): number | null {
    const off = Math.round(((parseInt(oldP) - parseInt(newP)) / oldP) * 100);
    return isNaN(off) ? null : off;
  }

  // ================= NAVIGATION =================
  productDetails(product: any): void {
    this.router.navigate([
      '/product',
      this._slugify.slugify(this.isAr ? product.name_ar : product.name_en),
      product.id
    ]);
  }
}
